import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMall"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM16 18.5V11H12.75V18.5H16ZM11.25 18.5V11H8V18.5H11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMall;
